// components/NotificationBanner.tsx
import React from "react";

type NotificationBannerProps = {
  message: string;
  bgColor: string;
};

const NotificationBanner: React.FC<NotificationBannerProps> = ({ message, bgColor }) => {
  return (
    <div className={`text-white flex !mx-[-20px] py-2 justify-start px-5 font-medium`} style={{ backgroundColor: bgColor }}>
      {message}
    </div>
  );
};

export default NotificationBanner;
